import React from "react";
import { Row } from "react-bootstrap";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import MasterDetailSection from "./MasterDetailSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/asistencia",
    label: "Asistencia",
  },
  {
    path: "/proyecciones",
    label: "Proyecciones",
    isActive: true,
  },
];

function HistorialVentas() {
  return (
    <Page
      title="Historial de ventas"
      description="Ventas históricas por año y mes."
      breadCrumbs={breadCrumbs}
    >
      <Row className="justify-content-center">
        <div className="col-xs-12 col-xxl-10">
          <MasterDetailSection />
        </div>
      </Row>
    </Page>
  );
}

export default HistorialVentas;
